<template>
  <section class="aerospace-section">
    <div class="container custom-container">
      
      <div class="aerospace-header">
        <span class="logo-tag">Automotive</span>
        <div class="full-divider"></div>
      </div>

      <div class="content-wrapper">
        
        <div class="title-column">
          <h2 class="main-title">Materials &<br>Surface Finishes</h2>
        </div>

        <div class="cards-column">
          <div class="info-card" v-for="(item, index) in cardList" :key="index">
            <div class="card-image">
              <img :src="item.image" :alt="item.title" />
            </div>
            
            <div class="card-body">
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-desc">{{ item.desc }}</p>
              
              <a :href="item.link" class="btn-primary">
                {{ item.btnText }}
                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="7" y1="17" x2="17" y2="7"></line>
                  <polyline points="7 7 17 7 17 17"></polyline>
                </svg>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

// 数据列表
const cardList = ref([
  {
    title: 'Materials',
    desc: 'We provide a wide range of materials, including metals, plastics, and composites.',
    btnText: 'View All Materials',
     image: require('@/assets/Industries/su_and_ma/3.png'), 
    link: '/materials-and-finishes'
  },
  {
    title: 'Surface Finishes',
    desc: 'We offer superior surface finishes that enhance part durability and aesthetics for applications requiring smooth or textured surfaces.',
    btnText: 'View All Surface Finishes',
   image: require('@/assets/Industries/su_and_ma/4.png'), 
    link: '/materials-and-finishes'
  }
]);
</script>

<style scoped>
/* --- 全局与背景 --- */
.aerospace-section {
  background-color: #171717 !important; 
  padding: 80px 20px !important;
  display: block !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.custom-container {
  max-width: 1200px !important;
  margin: 0 auto !important;
  width: 100% !important;
  display: block !important; /* 强制块级，防止被全局 flex 干扰 */
}

/* --- 顶部 Logo 标签与分割线 --- */
.aerospace-header {
  display: block !important;
  width: 100% !important;
  text-align: left !important;
}

.logo-tag {
  color: #16bc9c !important; 
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
  display: inline-block !important;
  margin: 0 !important;
}

/* 使用 div 替代 hr，确保不受全局样式干扰 */
.full-divider {
  width: 100% !important;
  height: 1px !important;
  background-color: #444444 !important; /* 匹配原图的深灰色实线 */
  margin: 12px 0 45px 0 !important; /* 精确还原间距 */
  display: block !important;
  border: none !important;
}

/* --- 布局容器 (左右分栏) --- */
.content-wrapper {
  display: flex !important;
  flex-direction: row !important;
  gap: 60px !important;
  align-items: flex-start !important;
}

/* --- 左侧标题栏 --- */
.title-column {
  flex: 0 0 300px !important; 
  margin: 0 !important;
  padding: 0 !important;
}

.main-title {
  font-size: 36px !important; /* 根据原图稍微放大标题 */
  font-weight: 400 !important;
  line-height: 1.3 !important;
  margin: 0 !important;
  color: #ffffff !important;
  text-align: left !important;
}

/* --- 右侧卡片网格 --- */
.cards-column {
  flex: 1 !important;
  display: grid !important;
  grid-template-columns: repeat(2, 1fr) !important; 
  gap: 30px !important;
}

/* --- 卡片样式 --- */
.info-card {
  background-color: #ffffff !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  height: 100% !important;
  box-sizing: border-box !important;
}

.card-image {
  width: 100% !important;
  height: 240px !important;
  overflow: hidden !important;
  background-color: #f5f5f5 !important;
}

.card-image img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important; 
  display: block !important;
}

/* --- 卡片内容区 --- */
.card-body {
  padding: 30px !important;
  display: flex !important;
  flex-direction: column !important;
  flex: 1 !important;
  box-sizing: border-box !important;
}

.card-title {
  color: #16bc9c !important; 
  font-size: 20px !important;
  font-weight: 400 !important;
  margin: 0 0 16px 0 !important;
  text-align: left !important;
}

.card-desc {
  color: #333333 !important; 
  font-size: 15px !important;
  line-height: 1.6 !important;
  margin: 0 0 30px 0 !important;
  flex: 1 !important; 
  text-align: left !important;
}

/* --- 按钮样式 --- */
.btn-primary {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  background-color: #16bc9c !important;
  color: #ffffff !important;
  padding: 12px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  border: none !important;
  cursor: pointer !important;
  align-self: flex-start !important; 
  transition: background-color 0.3s ease !important;
}

.btn-primary:hover {
  background-color:#027062 !important; 
}

/* --- 响应式适配 --- */
@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column !important; 
    gap: 40px !important;
  }
  
  .title-column {
    flex: auto !important;
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .cards-column {
    grid-template-columns: 1fr !important; 
  }
}
</style>